import type {
  SupabaseLocalizedByNumberRecord,
  SupabaseLocalizedByStringRecord,
  SupabaseLocalizedMessage,
  SupabaseMessageMapper,
} from "@/types";
import { normalizeSupabaseError } from "../base";

export function mapByAuthCode(
  map: SupabaseLocalizedByStringRecord,
): SupabaseMessageMapper {
  return (err) => {
    const n = normalizeSupabaseError(err);

    const code = n.code;
    if (!code) return null;

    const m = map[code];
    if (!m) return null;

    return {
      title: m.title,
      description: m.description,
      values: m.values,
      level: m.level,
      toasterId: m.toasterId,
    };
  };
}

export function mapByPgCode(
  map: SupabaseLocalizedByStringRecord,
): SupabaseMessageMapper {
  return (err) => {
    const n = normalizeSupabaseError(err);

    const code = n.code;
    if (!code) return null;

    const m = map[code];
    if (!m) return null;

    return {
      title: m.title,
      description: m.description,
      values: m.values,
      level: m.level,
      toasterId: m.toasterId,
    };
  };
}

export function mapByStatus(
  map: SupabaseLocalizedByNumberRecord,
): SupabaseMessageMapper {
  return (err) => {
    const n = normalizeSupabaseError(err);

    const st = n.status;
    if (typeof st !== "number") return null;

    const m = map[st];
    if (!m) return null;

    return {
      title: m.title,
      description: m.description,
      values: m.values,
      level: m.level ?? (st >= 500 ? "error" : "warning"),
      toasterId: m.toasterId,
    };
  };
}

export function mapByMessageIncludes(
  substr: string | RegExp,
  out: SupabaseLocalizedMessage,
): SupabaseMessageMapper {
  return (err) => {
    const anyErr = err as {
      message?: unknown;
      details?: unknown;
      hint?: unknown;
    };
    const candidates = [anyErr.message, anyErr.details, anyErr.hint].filter(
      (v): v is string => typeof v === "string" && v.length > 0,
    );
    if (candidates.length === 0) return null;

    const ok = candidates.some((s) =>
      typeof substr === "string" ? s.includes(substr) : substr.test(s),
    );
    if (!ok) return null;

    return {
      title: out.title,
      description: out.description,
      values: out.values,
      level: out.level,
      toasterId: out.toasterId,
    };
  };
}
